import { computed, ref } from 'vue';
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-22fb8ebb"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "table-content"
};
const _hoisted_2 = {
  class: "operation-area"
};
const _hoisted_3 = {
  class: "operation-left"
};
const _hoisted_4 = {
  class: "operation-right"
};
const _hoisted_5 = ["onClick"];
import { useRouter } from 'vue-router';
import { message } from 'ant-design-vue';
import { queryPromotionList, operatePromotion, exportPromotion } from '@/api/promotionApi';
import { useStore } from '@/store';
import { onActivated } from 'vue';
import { handleExportFile } from '@/common';
export default /*#__PURE__*/_defineComponent({
  __name: 'PromotionTableBlock',
  setup(__props, {
    expose
  }) {
    const router = useRouter();
    const userInfo = computed(() => useStore().userInfo && JSON.parse(useStore().userInfo));
    const columns = [{
      title: '序号',
      dataIndex: 'index',
      key: 'index',
      width: 80
    }, {
      title: '推广码名称',
      dataIndex: 'promotionName',
      key: 'promotionName'
    }, {
      title: '推广码ID',
      dataIndex: 'promotionCode',
      key: 'promotionCode'
    }, {
      title: '创建时间',
      dataIndex: 'createTime',
      key: 'createTime'
    }, {
      title: '过期时间',
      dataIndex: 'validTo',
      key: 'validTo'
    }, {
      title: '操作人',
      dataIndex: 'updateUser',
      key: 'updateUser'
    }, {
      title: '状态',
      dataIndex: 'promotionStatus',
      key: 'promotionStatus'
    }, {
      title: '操作',
      key: 'action',
      width: 150,
      fixed: 'right'
    }];
    const loading = ref(false);
    const dataSource = ref([]);
    const pageNum = ref(1);
    const pageSize = ref(10);
    const total = ref(0);
    const searchParams = ref({
      promotionInfo: '',
      dbtId: undefined,
      promotionStatus: undefined
    });
    const getData = async () => {
      loading.value = true;
      try {
        const params = {
          pageNum: pageNum.value,
          pageSize: pageSize.value,
          ...searchParams.value
        };
        const res = await queryPromotionList(params);
        if (res.code === '0') {
          var _res$data, _res$data2;
          dataSource.value = (((_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.list) || []).map((item, index) => ({
            ...item,
            index: (pageNum.value - 1) * pageSize.value + index + 1
          }));
          total.value = ((_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.total) || 0;
        } else {
          message.error(res.msg);
        }
      } catch (error) {
        message.error('获取数据失败');
      } finally {
        loading.value = false;
      }
    };
    const searchData = params => {
      if (!params.dbtId) {
        dataSource.value = [];
        return message.warn('请选择产品');
      }
      pageNum.value = 1;
      searchParams.value = params;
      getData();
    };
    const handleTableChange = (page, size) => {
      pageNum.value = page;
      pageSize.value = size;
      getData();
    };
    const handleAdd = () => {
      const dbtId = searchParams.value.dbtId;
      if (!dbtId) {
        message.error('请先选择产品');
        return;
      }
      router.push({
        path: '/promotionCodeAdd',
        query: {
          dbtId
        }
      });
    };
    const handleEdit = record => {
      router.push({
        path: '/promotionCodeAdd',
        query: {
          id: record.id,
          dbtId: searchParams.value.dbtId
        }
      });
    };
    const handleStatusChange = async record => {
      try {
        const params = {
          id: record.id,
          status: record.promotionStatus === 1 ? 0 : 1
        };
        const response = await operatePromotion(params);
        if (response.code === '0') {
          message.success('操作成功');
          pageNum.value = 1;
          getData();
        }
      } catch (error) {
        message.error('操作失败，请稍后重试');
      }
    };
    const handleExport = () => {
      // TODO: 实现导出功能
      handleQueryCanPromotionProdList({
        dbtId: searchParams.value.dbtId,
        promotionInfo: searchParams.value.promotionInfo,
        promotionStatus: searchParams.value.promotionStatus,
        productName: searchParams.value.productName
      });
    };
    const handleQueryCanPromotionProdList = async params => {
      try {
        handleExportFile(await exportPromotion(params), `${params.productName}推广表`, 'xlsx');
      } catch (error) {
        message.error('操作失败');
      }
    };
    expose({
      searchData
    });
    // 页面激活时更新表格
    onActivated(() => {
      if (searchParams.value.dbtId) {
        getData();
      }
    });
    return (_ctx, _cache) => {
      var _unref2;
      const _component_a_button = _resolveComponent("a-button");
      const _component_svg_icon = _resolveComponent("svg-icon");
      const _component_a_tag = _resolveComponent("a-tag");
      const _component_a_divider = _resolveComponent("a-divider");
      const _component_a_popconfirm = _resolveComponent("a-popconfirm");
      const _component_a_space = _resolveComponent("a-space");
      const _component_a_table = _resolveComponent("a-table");
      const _component_a_pagination = _resolveComponent("a-pagination");
      const _directive_permission = _resolveDirective("permission");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_withDirectives((_openBlock(), _createBlock(_component_a_button, {
        type: "primary",
        onClick: handleAdd
      }, {
        default: _withCtx(() => [_createTextVNode(" 新建推广码 ")]),
        _: 1
      })), [[_directive_permission, {
        permissionValue: 'promotionCodeList',
        permissionArr: (_unref2 = _unref(userInfo)) === null || _unref2 === void 0 ? void 0 : _unref2.permissions
      }]])]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_a_button, {
        onClick: handleExport
      }, {
        icon: _withCtx(() => [_createVNode(_component_svg_icon, {
          "icon-class": "export",
          "class-name": "download-icon"
        })]),
        default: _withCtx(() => [_createTextVNode(" 导出 ")]),
        _: 1
      })])]), _createVNode(_component_a_table, {
        bordered: "",
        columns: columns,
        "data-source": dataSource.value,
        "row-key": "id",
        pagination: false,
        loading: loading.value
      }, {
        bodyCell: _withCtx(({
          column,
          text,
          record
        }) => {
          var _unref3;
          return [column.key === 'index' ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [_createTextVNode(_toDisplayString(record.index), 1)], 64)) : _createCommentVNode("", true), column.key === 'promotionStatus' ? (_openBlock(), _createBlock(_component_a_tag, {
            key: 1,
            color: text === 1 ? 'green' : 'red'
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(text === 1 ? '有效' : '失效'), 1)]),
            _: 2
          }, 1032, ["color"])) : _createCommentVNode("", true), column.key === 'action' ? _withDirectives((_openBlock(), _createBlock(_component_a_space, {
            key: 2
          }, {
            default: _withCtx(() => [_createElementVNode("a", {
              onClick: $event => handleEdit(record)
            }, "编辑", 8, _hoisted_5), _createVNode(_component_a_divider, {
              type: "vertical"
            }), _createVNode(_component_a_popconfirm, {
              title: record.promotionStatus === 1 ? '确定停用该推广码？' : '确定启用该推广码？',
              onConfirm: () => handleStatusChange(record)
            }, {
              default: _withCtx(() => [_createElementVNode("a", null, _toDisplayString(record.promotionStatus === 1 ? '停用' : '启用'), 1)]),
              _: 2
            }, 1032, ["title", "onConfirm"])]),
            _: 2
          }, 1024)), [[_directive_permission, {
            permissionValue: 'promotionCodeList',
            permissionArr: (_unref3 = _unref(userInfo)) === null || _unref3 === void 0 ? void 0 : _unref3.permissions
          }]]) : _createCommentVNode("", true)];
        }),
        _: 1
      }, 8, ["data-source", "loading"]), _createVNode(_component_a_pagination, {
        class: "pagination",
        current: pageNum.value,
        "onUpdate:current": _cache[0] || (_cache[0] = $event => pageNum.value = $event),
        pageSize: pageSize.value,
        "onUpdate:pageSize": _cache[1] || (_cache[1] = $event => pageSize.value = $event),
        total: total.value,
        "show-size-changer": "",
        "show-total": total => `共 ${total} 条`,
        onChange: handleTableChange
      }, null, 8, ["current", "pageSize", "total", "show-total"])]);
    };
  }
});